import { useMutation, useQueryClient } from '@tanstack/react-query'
import { BrokeFlexMessageService } from '../services/BrokeFlexMessageService'
import { BROKE_FLEX_MESSAGE_KEYS } from '../../keys'

interface UseMutationCreateFromPresetOptions {
	onSuccess?: () => void
	onError?: (error: Error) => void
}

export default function useMutationCreateFromPreset({
	onSuccess,
	onError,
}: UseMutationCreateFromPresetOptions = {}) {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (dto: {
			preset: string
			promotionIds?: string[]
			couponCodes?: string[]
			includeReturnLoss?: boolean
			includeCommission?: boolean
			includeInviteFriend?: boolean
			maxItemsToShow?: number
			message: string
			isActive?: boolean
		}) => BrokeFlexMessageService.createFromPreset(dto),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: BROKE_FLEX_MESSAGE_KEYS.ALL,
			})
			onSuccess?.()
		},
		onError,
	})
}
